<template lang="pug">
  v-row(justify='center', align='center')
    v-col.text-center
      div
        v-container
          v-row.align-center.justify-center.text-justify
            v-col(cols="12")
              v-img.grey.darken-4(src='../assets/img-AtlasCOVID19-portada.jpg')
          v-row
            .col-md-12
              ul.social-network.social-circle
                li
                  a.icoFacebook(href='https://www.facebook.com/sharer/sharer.php?u=https://atlas-covid-19.bsigeo.net', title='Facebook')
                    i.fa.fa-facebook
                li
                  a.icoTwitter(href='https://twitter.com/intent/tweet?url=https://atlas-covid-19.bsigeo.net/', title='Twitter')
                    i.fa.fa-twitter
                li
                  a.icoLinkedin(href='https://www.linkedin.com/shareArticle?mini=true&url=https://atlas-covid-19.bsigeo.net/', title='Linkedin')
                    i.fa.fa-linkedin
          //- v-row
            v-col
              iframe(src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fatlas-covid-19.bsigeo.net%2F&width=197&layout=button_count&action=like&size=large&share=true&height=46&appId=401031546912737" width="197" height="46" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media")
            v-col
              a.twitter-share-button(href="https://twitter.com/intent/tweet?url=https://atlas-covid-19.bsigeo.net/" target="_blank") twitter
              div 
              script( type="IN/Share", data-url="https://atlas-covid-19.bsigeo.net/")
            //- a.IN-widget(href="https://www.linkedin.com/shareArticle?mini=true&url=https://atlas-covid-19.bsigeo.net/" target="_blank") linkedin

          v-row.align-center.justify-center.text-justify
           v-col(cols="1")
           v-col 
            p Analizar desde el punto de vista geográfico las diversas patologías que en el pasado han perjudicado y que actualmente siguen afectando al mundo, no sólo permite conocer las condiciones físico-sociales que favorecen su origen, desarrollo y propagación sobre el territorio, sino también, ayuda a relacionar estos factores con las condiciones socioeconómicas de la población que, en efecto, determinan su mayor o menor grado de vulnerabilidad. Este enfoque también permite tomar las decisiones necesarias para prevenir futuros contagios, controlar y mitigar los casos actuales y detener su propagación hacia otras regiones.
           v-col(cols="1")
          v-row.align-center.justify-center.text-justify
           v-col(cols="1")
           v-col 
            p 
              | Con la finalidad de divulgar información relevante y contribuir al interés general en relación con el virus SARS-CoV-2 y su distribución territorial en México y el mundo, Bufete de Soluciones Integrales, ha desarrollado el
              strong  “Atlas COVID-19” 
              | que es una herramienta web dinámica e interactiva, que tiene como objetivo principal, que los usuarios puedan consultar información histórica y actual, tomando en consideración la dimensión espacio-temporal de esta epidemia.
           v-col(cols="1")
      br
      h2 Selecciona un módulo
      div
        v-container
          v-row.align-center.justify-center
            // (cols="2", xs="6", md="4", lg="3")
            //- .col-xs-6.col-md-6.col-lg-3.col-xl-2
            v-col(cols="12", md="6", lg="6", xl="6", justify='center', align='center')
              v-hover
                v-card.v-card--raised.v-sheet.theme--light(@click="goTo('map')", supportingtext='true', image='true', style='width: 100%;  cursor: pointer;', slot-scope="{ hover }", :class="`elevation-${hover ? 12 : 2}`")
                  //- .d-flex.align-center.justify-center.v-sheet.theme--light.grey.lighten-3(style='height: 200px;')
                    i.v-icon.notranslate.mdi.mdi-image.theme--light(aria-hidden='true', style='font-size: 64px;')
                  .v-card__title.text-center(justify='center', align='center')
                    v-row
                      v-col(justify='center', align='center') Mapa dinámico
                  .v-card__text
                    v-row
                      v-col(justify='center', align='center')
                        v-img.grey.darken-4(src='../assets/mapa-dinamico-tm.png')
                    div.text-justify En el 
                      strong Mapa dinámico 
                      | podrás seleccionar por fecha y a nivel estatal, información referente a los casos confirmados acumulados, número de infectados de acuerdo al género y las muertes acumuladas. De igual manera, con este mapa podrás analizar la información de los casos confirmados acumulados, comparándola con 3 capas temáticas: 1) población total, 2) grado de marginación y 3) porcentaje de viviendas con hacinamiento. Al final de la sección, encontrarás gráficos que te permitirán complementar la información del mapa.
            v-col(cols="12", md="6", lg="6", xl="6", justify='center', align='center')
              v-hover
                v-card.v-card.v-card--raised.v-sheet.theme--light(@click="goTo('gallery')", supportingtext='true', image='true', style='width: 100%; cursor: pointer;', slot-scope="{ hover }", :class="`elevation-${hover ? 12 : 2}`")
                  //- .d-flex.align-center.justify-center.v-sheet.theme--light.grey.lighten-3(style='height: 200px;')
                    i.v-icon.notranslate.mdi.mdi-image.theme--light(aria-hidden='true', style='font-size: 64px;')
                  .v-card__title.text-center(justify='center', align='center')
                    v-row
                      v-col(justify='center', align='center') Mapas temáticos
                  // 
                  .v-card__text
                    v-col(justify='center', align='center')
                      v-img.grey.darken-4(src='../assets/mapas-tematidcos-tm.png')
                    //- v-row
                      v-col(cols="6", justify='center', align='center')
                        v-img.grey.darken-4(src='../assets/genero-tm.png')
                      v-col(cols="6", justify='center', align='center')
                        v-img.grey.darken-4(src='../assets/hacinamiento-tm.jpg')
                    //- v-row
                      v-col(cols="6", justify='center', align='center')
                        v-img.grey.darken-4(src='../assets/mundial-2-tm.png')
                      v-col(cols="6", justify='center', align='center')
                        v-img.grey.darken-4(src='../assets/procedencia-tm.png')
                    div.text-justify En esta sección tienes a tu disposición un catálogo de 
                      strong Mapas temáticos 
                      | tanto a nivel mundial como nacional. En el ámbito internacional, podrás obtener información de la evolución de la pandemia de acuerdo con los casos confirmados, las muertes y los casos recuperados de cada país. Por otra parte, en el contexto nacional, encontrarás mapas que muestran los casos confirmados acumulados de acuerdo con la procedencia del contagio, el género, población total, grupos de edad, grado de marginación y porcentaje de hacinamiento.
      //- img(alt='BSI', src='../assets/Logos-BSI-GShare-21.png')
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: 'Home',
  components: {},
  methods: {
    goTo(name) {
      this.$router.push({ name: name })
    }
  }
}
</script>

<style lang="css" scoped>
/*=========================
  Icons
 ================= */

/* footer social icons */
ul.social-network {
  list-style: none;
  display: inline;
  margin-left: 0 !important;
  padding: 0;
}
ul.social-network li {
  display: inline;
  margin: 0 5px;
}

/* footer social icons */
.social-network a.icoRss:hover {
  background-color: #f56505;
}
.social-network a.icoFacebook:hover {
  background-color: #3b5998;
}
.social-network a.icoTwitter:hover {
  background-color: #33ccff;
}
.social-network a.icoGoogle:hover {
  background-color: #bd3518;
}
.social-network a.icoVimeo:hover {
  background-color: #0590b8;
}
.social-network a.icoLinkedin:hover {
  background-color: #007bb7;
}
.social-network a.icoRss:hover i,
.social-network a.icoFacebook:hover i,
.social-network a.icoTwitter:hover i,
.social-network a.icoGoogle:hover i,
.social-network a.icoVimeo:hover i,
.social-network a.icoLinkedin:hover i {
  color: #fff;
}
a.socialIcon:hover,
.socialHoverClass {
  color: #44bcdd;
}

.social-circle li a {
  display: inline-block;
  position: relative;
  margin: 0 auto 0 auto;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  text-align: center;
  width: 50px;
  height: 50px;
  font-size: 20px;
}
.social-circle li i {
  margin: 0;
  line-height: 50px;
  text-align: center;
}

.social-circle li a:hover i,
.triggeredHover {
  -moz-transform: rotate(360deg);
  -webkit-transform: rotate(360deg);
  -ms--transform: rotate(360deg);
  transform: rotate(360deg);
  -webkit-transition: all 0.2s;
  -moz-transition: all 0.2s;
  -o-transition: all 0.2s;
  -ms-transition: all 0.2s;
  transition: all 0.2s;
}
.social-circle i {
  color: #fff;
  -webkit-transition: all 0.8s;
  -moz-transition: all 0.8s;
  -o-transition: all 0.8s;
  -ms-transition: all 0.8s;
  transition: all 0.8s;
}

a {
  background-color: #d3d3d3;
}
</style>
